import { Controller } from "@hotwired/stimulus"

// Keeps a destructive button disabled until the typed text matches the expected
// value (the email of the account to delete): a deliberate act, not a stray click.
export default class extends Controller {
  static targets = ["input", "button"]
  static values = { expected: String }

  connect() {
    this.check()
  }

  check() {
    const matches = this.inputTarget.value.trim().toLowerCase() === this.expectedValue.toLowerCase()
    this.buttonTarget.disabled = !matches
  }
}
